export default __webpack_public_path__ + "static/media/ordi1.6467bc7f.jpg";